import { isEmpty } from 'lodash';
import { makeApiGetRequest, makeApiPatchRequest, makeApiPostRequest } from './apiActions';
import VocaboServiceClient from '../clients/VocaboServiceClient';
import { setResult } from './resultActions';
import selectors from '../../rootSelectors';
import { stopQuestionTimeTracking } from '../timeTracking/timeTrackingActions';

export const createResult = (measure, formId, language) => {
    return (dispatch, getStore) => {
        const state = getStore();
        const instId = selectors.getInstId(state, measure);
        const postBody = {
            grade_level: selectors.getGrade(state),
            inst_uid: instId,
            period: selectors.getToy(state),
            school_year: selectors.getSchoolYear(state),
            student_uid: selectors.getUserId(state),
            assessment_mode: 'online',
            assessment: VocaboServiceClient.NAME,
            student_temporal_id: selectors.getStudentTemporalId(state, instId) || undefined, // unset if not available
            form_id: formId,
            language,
            measure,
        };
        const endpoint = VocaboServiceClient.constructCreateResultEndpoint();

        return dispatch(makeApiPostRequest(endpoint, postBody)).then(resultJson => {
            dispatch(setResult(resultJson));
            return resultJson.result_id;
        });
    };
};

export const saveResultResponse = (
    resultId,
    itemId,
    itemIndex,
    formId,
    responseId,
    measure,
    duration,
    markComplete = false,
) => dispatch => {
    const patchData = {
        operation: VocaboServiceClient.RESULT_OPERATION.ADD_RESPONSE,
        measure,
        data: {
            item_id: itemId,
            item_idx: itemIndex,
            form_id: formId,
            response_id: responseId,
            time_duration: duration,
            mark_complete: markComplete,
        },
    };
    const endpoint = VocaboServiceClient.constructSaveResultEndpoint(resultId);

    return dispatch(makeApiPatchRequest(endpoint, patchData));
};

export const saveMeasureResponse = (
    measure,
    itemId,
    itemIndex,
    formId,
    language,
    response,
    markComplete = false,
) => async (dispatch, getStore) => {
    dispatch(stopQuestionTimeTracking());

    const state = getStore();
    const duration = selectors.getQuestionTimeTrackingDuration(state);
    const result = selectors.findResultFor(state, {
        measure,
        formId,
        isComplete: false,
    });
    const resultId = result ? result.id : await dispatch(createResult(measure, formId, language));

    return dispatch(
        saveResultResponse(
            resultId,
            itemId,
            itemIndex,
            formId,
            response,
            measure,
            duration,
            markComplete,
        ),
    );
};

export const getStudentResults = measure => {
    return (dispatch, getStore) => {
        const state = getStore();
        const studentId = selectors.getUserId(state);
        const grade = selectors.getGrade(state);
        const period = selectors.getToy(state);
        const schoolYear = selectors.getSchoolYear(state);
        const language = selectors.getPlaylistActiveLanguages(state).join(',');
        const config = {
            ...(measure !== undefined ? { measure } : {}),
            studentId,
            grade,
            period,
            schoolYear,
            language,
        };
        const endpoint = VocaboServiceClient.constructResultListEndpoint(config);

        return dispatch(makeApiGetRequest(endpoint)).then(data => {
            const resultsData = isEmpty(data) ? [] : data.results;
            resultsData.forEach(resultData => {
                dispatch(setResult(resultData));
            });
        });
    };
};
